import script from "./ClinicInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicInfo.vue?vue&type=script&setup=true&lang=js"

import "./ClinicInfo.vue?vue&type=style&index=0&id=0d0ef8c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d0ef8c4"]])

export default __exports__